import { useIsAccountNavBarEnabled } from "#src/components/Layout/LayoutContentHelpers";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import React from "react";
import { Nav, NavItem, Tab } from "react-bootstrap";
import { connect } from "react-redux";
import config from "../../../config";
import { SetCleanHistoryPath } from "../../../Routers/historyHelper";
import { linkToUserSetting } from "../../../Routers/links";
import { havePermission } from "../../Redux/reducers/permissions";
import SettingSection from "../SettingSection";
import ApiTokens from "./ApiTokens/ApiTokens";
import Notifications from "./Notifications/Notifications";
import Profile from "./Profile";
import UserActivity from "./UserActivity/UserActivity";
import styles from "./UserSettings.module.scss";

const cx = classNames.bind(styles);

const DEFAULT_TAB = "profile";

const NavLink = (props) => (
  <li>
    <a
      href={props.link}
      target="_blank"
      rel="noreferrer"
    >
      {props.title}
    </a>
  </li>
);

const mapStateToProps = (state) => {
  return {
    hasReadPermission: havePermission(state.permissions)(
      "core:user.management",
      "read"
    ),
    hasNotificationPermission: havePermission(state.permissions)(
      "core:notifications",
      "read"
    ),
  };
};

const UserSettings = (props) => {
  const paramKey = props.match.params.tab;
  const profile = props.profile.toJS();
  const tabKey = paramKey || DEFAULT_TAB;

  const isAccountNavBarEnabled = useIsAccountNavBarEnabled();

  const onSelect = (eventKey) => {
    const link = linkToUserSetting(eventKey);
    SetCleanHistoryPath(link);
  };

  return (
    <Tab.Container
      className={cx("userSettings")}
      id="userSettings__tabs"
      activeKey={tabKey}
      onSelect={onSelect}
    >
      <div className={cx("userSettings__tabs")}>
        <div className={cx("userSettings__navs")}>
          <div className={cx("userSettings__navsHeader")}>Account</div>
          <Nav stacked>
            <NavItem eventKey="profile">Profile</NavItem>

            {props.hasNotificationPermission ? (
              <NavItem eventKey="notifications">Notifications</NavItem>
            ) : null}

            {props.hasReadPermission ? (
              <NavItem eventKey="activities">Activities</NavItem>
            ) : null}

            {props.hasReadPermission ? (
              <NavItem eventKey="apiTokens">API Tokens</NavItem>
            ) : null}

            <NavLink
              link={config.PRIVACY_POLICY_URL}
              title="Privacy Policy"
            />

            <NavLink
              link={config.TERMS_OF_SERVICE_URL}
              title="Terms of Service"
            />

            <NavLink
              link={config.RELEASE_NOTE_URL}
              title="Release Notes"
            />
          </Nav>
        </div>
        <div
          className={cx(
            "userSettings__content",
            isAccountNavBarEnabled && "has-nav-bar"
          )}
        >
          <Tab.Content animation>
            <Tab.Pane eventKey="profile">
              <Profile
                // @ts-expect-error legacy opshub typing
                profile={profile}
                height={props.height}
              />
            </Tab.Pane>

            {props.hasNotificationPermission ? (
              <Tab.Pane eventKey="notifications">
                <Notifications
                  // @ts-expect-error legacy opshub typing
                  profile={profile}
                  height={props.height}
                />
              </Tab.Pane>
            ) : null}

            {props.hasReadPermission ? (
              <Tab.Pane eventKey="activities">
                <SettingSection title="My Activities">
                  <UserActivity
                    userId={profile.id}
                    height={props.height}
                  />
                </SettingSection>
              </Tab.Pane>
            ) : null}

            {props.hasReadPermission ? (
              <Tab.Pane eventKey="apiTokens">
                {/* @ts-expect-error legacy opshub typing */}
                <ApiTokens
                  userId={profile.id}
                  height={props.height}
                />
              </Tab.Pane>
            ) : null}
          </Tab.Content>
        </div>
      </div>
    </Tab.Container>
  );
};

NavLink.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

UserSettings.propTypes = {
  height: PropTypes.number,
  match: PropTypes.object,
  profile: PropTypes.object,
  hasReadPermission: PropTypes.bool,
  hasNotificationPermission: PropTypes.bool,
};

export default connect(mapStateToProps, null)(UserSettings);
